<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/e7QIIL/tc-custom/9780823294480.jpg?1716643344133" alt="This image is the cover for the book Medieval Nonsense"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Medieval Nonsense
      </h1>
      <p class="bookDescription body article font2">
        <p>Five hundred years before “Jabberwocky” and <i>Tender Buttons</i>, writers were already preoccupied with the question of nonsense. But even as the prevalence in medieval texts of gibberish, babble, birdsong, and allusions to bare voice has come into view in recent years, an impression persists that these phenomena are exceptions that prove the rule of the period’s theologically motivated commitment to the kernel of meaning over and against the shell of the mere letter.<br/><br/>This book shows that, to the contrary, the foundational object of study of medieval linguistic thought was <i>vox</i><i>non-significativa</i>, the utterance insofar as it means nothing whatsoever, and that this fact was not lost on medieval writers of various kinds. In a series of close and unorthodox readings of works by Priscian, Boethius, Augustine, Walter Burley, Geoffrey Chaucer, and the anonymous authors of the <i>Cloud of Unknowing</i> and <i>St. Erkenwald</i>, it inquires into the way that a number of fourteenth-century writers recognized possibilities inherent in the accounts of language transmitted to them from antiquity and transformed those accounts into new ideas, forms, and practices of non-signification. Retrieving a premodern hermeneutics of obscurity in order to provide materials for an archeology of the category of the literary, <i>Medieval Nonsense</i> shows how these medieval linguistic textbooks, mystical treatises, and poems were engineered in such a way as to arrest the faculty of interpretation and force it to focus on the extinguishing of sense that occurs in the encounter with language itself.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jordan Kirk
      </h2>
      
      <p class="authorDescription body article"><B>Jordan Kirk</B> is Associate Professor of English at Pomona College.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Fordham University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?239a373c